export default __webpack_public_path__ + "static/media/4.44cf1ec7.jpg";